import React, { useEffect, useState } from 'react'
import { BigTableView, MRDetailsCard, useDebounce } from '../../../_metronic/layout/components/RhEALComponent'
import * as excel from "exceljs";

const SubmissionData: React.FC = () => {

  const [myLoading, setMyLoading] = useState<boolean>(false);
  const [DateToggle, setDateToggle] = useState<boolean>(false);
  const [subData, setSubData] = useState<any[]>([])
  const [subDataExport, setSubDataExport] = useState<any[]>([])
  const [searchResult, setSearchResult] = useState<string>("");
  const [filterData, setFilterData] = useState<string>("")
  const [fromDate, setFromDate] = useState<string | number | Date>("");
  const [toDate, setToDate] = useState<string | number | Date>("");
  const [pageNumber, setPageNumber] = useState<number>(1)
  const [totalRecords, setTotalRecords] = useState<number>(0)
  const debounceVal = useDebounce(searchResult, 700);
  const [exportDisabled, setExportDisabled] = useState(false)

  const limit = 8;

  let fDate = new Date(fromDate)
  fDate = new Date(Date.UTC(fDate.getFullYear(), fDate.getMonth(), fDate.getDate()));

  let TFate = new Date(toDate)
  TFate = new Date(Date.UTC(TFate.getFullYear(), TFate.getMonth(), TFate.getDate()));

  useEffect(() => {
    getSubList();
    getSubListExport();
  }, [filterData, debounceVal, pageNumber, DateToggle])

  const getSubList = () => {
    setMyLoading(true);

    const getMRObj = {
      page: pageNumber,
      zone_id: filterData,
      searchMrName: debounceVal,
      limit: limit,
      fromDate: fDate,
      toDate: TFate,
    };
    fetch(`${process.env.REACT_APP_API_URL_MAIN}get_submission_list`, {
      method: "POST",
      headers: {},
      body: JSON.stringify(getMRObj),
    })
      .then((result) => {
        result.json().then((response) => {
          if (response.status === 1) {
            setSubData(response?.data);
            setTotalRecords(response?.total_records)
            setMyLoading(false);
          } else {
            setMyLoading(false);
          }
        });
      })
      .catch(() => {
        setMyLoading(false);
      });
  };

  const getSubListExport = () => {
    setMyLoading(true);

    const getMRObj = {
      page: pageNumber,
      zone_id: filterData,
      searchMrName: debounceVal,
      fromDate: fromDate as string,
      toDate: toDate as string,
    };
    fetch(`${process.env.REACT_APP_API_URL_MAIN}get_submission_list_export`, {
      method: "POST",
      headers: {},
      body: JSON.stringify(getMRObj),
    })
      .then((result) => {
        result.json().then((response) => {
          if (response.status === 1) {
            setSubDataExport(response?.data);
            setMyLoading(false);
            setExportDisabled(true);
          } else {
            setMyLoading(false);
            setExportDisabled(false);
          }
        });
      })
      .catch(() => {
        setMyLoading(false);
      });
  };


  // const handleExport = () => {
  //   const workbook = new excel.Workbook();
  //   const worksheet = workbook.addWorksheet("Sheet 1");

  //   // add data to worksheet
  //   worksheet.columns = [
  //     { header: "Date", key: "Date", width: 20 },
  //     { header: "MR name", key: "MR name", width: 20 },
  //     { header: "Zone Name", key: "Zone Name", width: 40 },
  //   ];
  //   worksheet.addRows(['subData', 'subData', 'subData']);
  //   workbook.xlsx.writeBuffer().then((buffer) => {
  //     const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  //     const url = URL.createObjectURL(blob);
  //     const a = document.createElement("a");
  //     a.href = url;
  //     a.download = "data.xlsx";
  //     a.click();
  //   });
  // };

  return (
    <>
      <MRDetailsCard exportDisabled ={exportDisabled} data={subDataExport} setDateToggle={setDateToggle} dateToggle={DateToggle} setSearchResult={setSearchResult} setPageNumber={setPageNumber} pageNumber={pageNumber} limit={limit} fromDate={fromDate} setFromDate={setFromDate} toDate={toDate} setToDate={setToDate} setFilterData={setFilterData} filterData={filterData} />
      <BigTableView totalRecords={totalRecords} setPageNumber={setPageNumber} limit={limit} pageNumber={pageNumber} filterData={filterData} searchData={debounceVal} fromDate={fromDate as string} toDate={toDate as string} data={subData} loading={myLoading} />
    </>
  )
}

export { SubmissionData }
